import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    ADD_INDUSTRY: (industry) => ({ industry }),
    API: {
      ADD_INDUSTRY: apiResourceActionCreator('industry')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/add-industry`, authToken, payload.industry, actions.admin.api.addIndustry);

function* addIndustry(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));

  const result = yield apiActionResult(actions.admin.api.addIndustry);

  if (result.success) {
    yield put(push({ pathname: routes.adminPortal.industry }));
  }
}

const configuration = {
  name: 'addIndustry',
  action: actions,
  sagas: addIndustry,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isUpdating: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/addIndustry.js